<div class="template3 " (click)="$event.stopImmediatePropagation()" [class.open]="aboutMenuCollapsed">
    <div class="mega-menu" slimScroll id="mega-menu-container" width="auto" size="3px" height="inherit"
        alwaysVisible="true" wheelStep="15" touchScrollStep="40">
        <div class="row aboutus-block">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 mobile-padding">
                <div class="list-block category-section">
                    <a class="title font-size-14 d-none d-md-block" #aboutustitle tabindex="0"
                        attr.aria-label=" {{'megamenu.Learn More About Forever' |translate|translateKey}}"
                        title="{{'megamenu.Learn More About Forever' |translate|translateKey}}">
                        {{'megamenu.Learn More About Forever' |translate|translateKey}}
                    </a>
                    <ul class="list-unstyled my-md-3">
                        <li>
                            <a class="d-none d-md-inline" tabindex="0" (click)="navigateToAboutSite(routePath.ABOUT)"
                                attr.aria-label="{{'megamenu.About Forever Living' |translate|translateKey}}">{{'megamenu.About Forever Living' |translate|translateKey}}</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToAboutSite(routePath.ABOUT)"
                                (click)="setCollapse(false,$event);navigateToAboutSite(routePath.ABOUT)">
                                <span class="col p-0" tabindex="0"
                                    attr.aria-label="{{'megamenu.About Forever Living'|translate|translateKey}}">{{'megamenu.About Forever Living' |translate|translateKey}}</span>
                            </a>
                        </li>
                        <li>
                            <a class="d-none d-md-inline" tabindex="0"
                                (click)="navigateToAboutSite(routePath.FROM_PLANT_TO_PRODUCT_TO_YOU)"
                                attr.aria-label="{{'megamenu.From Plant to Product to You'|translate|translateKey}}">{{'megamenu.From Plant to Product to You' |translate|translateKey}}</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToAboutSite(routePath.FROM_PLANT_TO_PRODUCT_TO_YOU)"
                                (click)="setCollapse(false,$event);navigateToAboutSite(routePath.FROM_PLANT_TO_PRODUCT_TO_YOU)">
                                <span class="col p-0" tabindex="0"
                                    attr.aria-label="{{'megamenu.From Plant to Product to You'}}">{{'megamenu.From Plant to Product to You' |translate|translateKey}}</span>
                            </a>
                        </li>
                        <li>
                            <a class="d-none d-md-inline" tabindex="0" attr.aria-label="{{'megamenu.FAQ'|translate|translateKey}}"
                                (click)="navigateToAboutSite(routePath.ForeverLivingFAQ)">{{'megamenu.FAQ'|translate|translateKey}}</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToAboutSite(routePath.ForeverLivingFAQ)"
                                (click)="setCollapse(false,$event);navigateToAboutSite(routePath.ForeverLivingFAQ)">
                                <span class="col p-0" tabindex="0" attr.aria-label="{{'megamenu.FAQ'|translate|translateKey}}">{{'megamenu.FAQ'|translate|translateKey}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md col-lg d-none d-md-block main-block">
                <div class="list-block">
                    <a class="title font-size-14" [style.min-height.px]="aboutustitle.offsetHeight" tabindex="0"
                        title="{{'megamenu.From The Blog' |translate|translateKey}}"
                        attr.aria-label="{{'megamenu.From The Blog' |translate|translateKey}}">
                        {{'megamenu.From The Blog' |translate|translateKey}}
                    </a>
                    <div [attr.data-t-card]="'5'" appDynamicNavigation (isNavClicked)="navigateToPortal($event)"
                        id="card1" class="static-content">
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-auto col-lg-auto d-none d-md-block contact_us__block">
                <div class="list-block">
                    <a class="title font-size-14" [style.min-height.px]="aboutustitle.offsetHeight"
                        title="{{'megamenu.Contact Us'|translate|translateKey}}" tabindex="0"
                        attr.aria-label="{{'megamenu.Contact Us'|translate|translateKey}}">
                        {{'megamenu.Contact Us'|translate|translateKey}}
                    </a>
                    <div *ngIf="mapLocation">
                        <!-- Contact Information -->
                        <div class="contact__name pt-3 pb-2">{{mapLocation.name}}</div>
                        <div *ngIf="mapLocation.address1">{{mapLocation.address1}},</div>
                        <div *ngIf="mapLocation.address2">{{mapLocation.address2}}</div>
                        <div *ngIf="mapLocation.phone || mapLocation.emailID" class="contact__name pt-2">
                            {{'megamenu.Customer Support'|translate|translateKey}}:</div>
                        <div *ngIf="mapLocation.phone">{{mapLocation.phone}}</div>
                        <div *ngIf="mapLocation.emailID" class="contact__email"><a href="mailto:{{mapLocation.emailID}}">{{mapLocation.emailID}}</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>